<section>
  <mat-card>
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate" data-qa-id="feeds-detail-progress-loading"></mat-progress-bar>
    }
    @if (!isLoading) {
      <form #feedConfigurationForm="ngForm" (ngSubmit)="onSubmit(feedConfigurationForm)" class="feed-configuration-form">
        <mat-card-header>
          <mat-card-title>
            <h1>Feed Configuration</h1>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="row" fxLayoutAlign="start start">
            <div fxFlex="auto" fxLayout="column" fxLayoutAlign="space-between start">
              <mat-form-field class="column-form">
                <mat-label>Name</mat-label>
                <input matInput
                  name="name"
                  [(ngModel)]="model.Name"
                  value=""
                  required
                  (blur)="checkFeedNameUnique()"
                  id="feed-name-input"
                  data-qa-id="feeds-detail-input-name">
              </mat-form-field>
              <br />
              <mat-form-field class="column-form">
                <mat-label>Description</mat-label>
                <input matInput
                  name="description"
                  [(ngModel)]="model.Description"
                  value=""
                  id="feed-description-input"
                  data-qa-id="feeds-detail-input-description">
              </mat-form-field>
              <br />
              <mat-form-field class="column-form">
                <mat-label>SFTP Folder Path</mat-label>
                <input matInput
                  name="SftpLocation"
                  [(ngModel)]="model.SftpLocation"
                  value=""
                  required
                  (blur)="checkFolderFilePatternUnique()"
                  pattern="^\/.*"
                  id="feed-sftp-location-input"
                  data-qa-id="feeds-detail-input-folder-location">
                <mat-hint>
                  SFTP Folder Path: /Client Folders/(Client)/(Feed) - The clients region will determine the correct SFTP server.
                </mat-hint>
              </mat-form-field>
              <br />
              <mat-form-field class="column-form">
                <mat-label>File Name Regex</mat-label>
                <input matInput
                  name="fileNameRegex"
                  [(ngModel)]="model.FileNameRegex"
                  value=""
                  required
                  id="feed-file-name-regex-input"
                  data-qa-id="feeds-detail-input-file-name-regex">
                <mat-hint>
                  Enter a regex which will be used to validate the file name when a file is manually dropped for processing
                </mat-hint>
              </mat-form-field>
              <br />
              <mat-form-field style="max-width:300px;display: none;">
                <mat-label>File Pattern</mat-label>
                <input matInput
                  name="filePattern"
                  [(ngModel)]="model.FilePattern"
                  value=""
                  required
                  readonly="readonly"
                  id="feed-file-pattern-input">
                <mat-hint>
                  (readonly) File extension to be used
                </mat-hint>
              </mat-form-field>
            </div>
            <div fxFlex="auto" fxLayout="column wrap" fxLayoutAlign="space-between none" class="optionBox">
              @if (!isModuleRecordFeed()) {
                <mat-form-field class="threshold">
                  <mat-label>Threshold (%)</mat-label>
                  <input class="module-record-input"
                    matInput
                    type="number"
                    min="0"
                    max="100"
                    name="threshold"
                    [(ngModel)]="model.Threshold"
                    id="feed-threshold-input" />
                  <mat-hint>
                    Optional threshold - Set the % difference (+/-) allowed for the number of rows in the current feed Vs previous feed. 0% will ignore row count validation.
                  </mat-hint>
                </mat-form-field>
              }
              <mat-form-field>
                <mat-label>Feed Type</mat-label>
                <mat-select matInput name="FeedType" [(ngModel)]="model.FeedType" (selectionChange)="feedSelectionChanged()" id="feed-type-dropdown" data-qa-id="feeds-detail-select-feed-type">
                  @for (dt of feedTypes; track dt) {
                    <mat-option [value]="dt.Key" id="feed-type-dropdown-{{dt.Key}}">
                      {{ dt.FriendlyName }}
                    </mat-option>
                  }
                </mat-select>
                <mat-hint>Select a feed type.</mat-hint>
              </mat-form-field>
              @if (model.FeedType === 'PermissionFeed') {
                <div>
                  <mat-form-field>
                    <mat-label>AVA Identifier</mat-label>
                    <mat-select [(ngModel)]="model.SSOAvaIdentifier" name="SSOAvaIdentifier" (change)="checkIdentifierCount()" id="feed-sso-identifier-dropdown">
                      <mat-option id="feed-sso-identifier-dropdown-email" value="Email">Email</mat-option>
                      <mat-option id="feed-sso-identifier-dropdown-username" value="Username">Username</mat-option>
                      <mat-option id="feed-sso-identifier-dropdown-user-id" value="UserId">UserId</mat-option>
                    </mat-select>
                    <mat-hint>Select a field to map to the feed identifier.</mat-hint>
                  </mat-form-field>
                </div>
              }
              @if (isModuleRecordFeed()) {
                <div>
                  <div>
                    <mat-form-field>
                      <mat-label>Module</mat-label>
                      <mat-select name="Module" [(ngModel)]="model.ModuleId" (selectionChange)="moduleChanged()" required id="feed-module-name-dropdown">
                        @for (module of recordFeedModules; track module) {
                          <mat-option [value]="module.ModuleId" id="feed-module-name-dropdown-{{module.ModuleId}}">
                            {{ module.ModuleName | translate: 'Text' | async }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-hint>Select a module.</mat-hint>
                    </mat-form-field>
                  </div>
                  <div>
                    <mat-form-field>
                      <mat-label>State</mat-label>
                      <mat-select name="State" [(ngModel)]="model.StateId" (selectionChange)="stateChanged()" required id="feed-state-dropdown">
                        @for (state of states; track state) {
                          <mat-option [value]="state.Id" id="feed-state-dropdown-{{state.Id}}">
                            {{ state.Name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-hint>Select a state.</mat-hint>
                    </mat-form-field>
                  </div>
                  <mat-slide-toggle name="allow-deactivated-sites" [(ngModel)]="model.AllowRecordsForDeactivatedSites" id="feed-include-deactivated">
                    Allow feeding records to deactivated sites?
                  </mat-slide-toggle>
                </div>
              }
              <mat-slide-toggle name="email-on-success" [(ngModel)]="model.EmailOnSuccess" id="feed-email-on-success">
                Email On Success
              </mat-slide-toggle>
              @if (showEmailInput()) {
                <div>
                  <mat-form-field class="column-form">
                    <mat-label>Email</mat-label>
                    <input matInput
                      name="email"
                      [(ngModel)]="model.EmailAddress"
                      pattern="{{ multipleEmailValidation }}"
                      id="feed-email-input">
                    <mat-hint>
                      Optional - leave blank to email all system administrators. Separate multiple addresses with a comma, semicolon, pipe, space or tab.
                    </mat-hint>
                  </mat-form-field>
                </div>
              }
              <mat-slide-toggle name="disable-client-notifications" [(ngModel)]="model.DisableClientNotifications" id="feed-disable-client-notifications">
                Restrict Emails to EcoOnline Administrators
              </mat-slide-toggle>
              <div class="toggle-hint" id="feed-disable-client-notifications-hint">
                Limits feed emails to internal EcoOnline administrators. This applies to failure emails, and to success emails when no Email On Success address is given. An Email On Success address is always emailed, whether or not this is switched on.
              </div>
            </div>
          </div>
          <br />
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
              <mat-slide-toggle name="bulkAddUpdateEnabled" [(ngModel)]="model.BulkAddUpdateEnabled" id="bulk-add-update-enabled" data-qa-id="feeds-detail-toggle-bulk-add-update">
                Allow Bulk Update/Add
              </mat-slide-toggle>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
              <mat-slide-toggle name="enabled" [(ngModel)]="model.Enabled" id="feed-enabled" data-qa-id="feeds-detail-toggle-enabled">
                Enabled
              </mat-slide-toggle>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="10px">
              <button mat-raised-button type="button"
                (click)="fetchFileButtonClick(model.SftpLocation,model.FilePattern)"
                [disabled]="!feedConfigurationForm.form.controls.SftpLocation?.valid"
                class="mat-raised-button pull-right"
                color="accent"
                id="feed-fetch-file" data-qa-id="feeds-detail-btn-fetch-file">
                Fetch File
              </button>
            </div>
          </div>
          @if (isModuleRecordFeed() || isHierarchyFeed()) {
            <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
              <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button mat-raised-button type="button"
                  (click)="autoMapFields()"
                  [disabled]="autoMapButtonDisabled()"
                  class="mat-raised-button pull-right"
                  color="accent"
                  id="auto-map-fields">
                  Auto-Map Fields
                </button>
                <mat-slide-toggle
                  [(ngModel)]="overwritePreviousMappings"
                  name="overwritePreviousMappings"
                  id="overwrite-previous-mappings">
                  Overwrite previous mappings
                </mat-slide-toggle>
              </div>
            </div>
          }
          <br />
          @if (feedNameErrorText) {
            <div class="error-message-container with-icon pull-right">
              <mat-icon>error</mat-icon><strong>{{feedNameErrorText}}</strong>
            </div>
          }
          @if (filePathErrorText) {
            <div class="error-message-container with-icon pull-right">
              <mat-icon>error</mat-icon><strong>{{filePathErrorText}}</strong>
            </div>
          }
          @if (fetchFileErrorText) {
            <div class="error-message-container with-icon pull-right">
              <mat-icon>error</mat-icon><strong>{{fetchFileErrorText}}</strong>
            </div>
          }
          @if (identifierErrorText) {
            <div class="error-message-container with-icon pull-right">
              <mat-icon>error</mat-icon><strong>{{identifierErrorText}}</strong>
            </div>
          }
          @if (!fileNameRegexIsValidRegex()) {
            <div class="error-message-container with-icon pull-right">
              <mat-icon>error</mat-icon><strong>{{fileNameRegexErrorText}}</strong>
            </div>
          }
          @if (!moduleIsEnabled && this.isModuleRecordFeed()) {
            <div class="error-message-container with-icon pull-right">
              <mat-icon>error</mat-icon><strong>The module associated with this feed is disabled.</strong>
            </div>
          }
          <div class="clear"></div>
          @if (!isSSOFeedValid()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong>
                You must select a hierarchy field, one identifier field and AVA identifier when SSO Feed is
                selected.
              </strong>
            </div>
          }
          @if (!isOshaEstablishmentFeedValid()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong>
                You must map the Establishment Name column.
              </strong>
            </div>
          }
          @if (!isHierarchyOshaAttributesFeedValid()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong>
                You must map the Hierarchy Short Name and Establishment Name columns.
              </strong>
            </div>
          }
          @if (!isHierarchyFeed()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong> Please select the fields that are to be used in the system.</strong>
            </div>
          }
          @if (!model.StateId && isModuleRecordFeed()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong>A list of required fields will show once a module and state have been selected.</strong>
            </div>
          }
          @if (isPermissionFeed()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong>Please ensure you have selected, as a minumum, an identifier field (e.g. name or email) and a hierarchy field.</strong>
            </div>
          }
          @if (formFlowFields && isModuleRecordFeed()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              @if (getMandatoryFormflowFields().length > 0) {
                <div>
                  <strong>The following fields are required for this feed:</strong>
                  <ul>
                    @for (field of getMandatoryFormflowFields(); track field) {
                      <li>{{field.Label}}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
          @if (isHierarchyFeed()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong> Please select the fields that are to be used in Hierarchy Mapping.</strong>
            </div>
          }
          @if (isOshaEstablishmentFeed()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong> Please map one and only one field to the ID.</strong>
            </div>
          }
          <table>
            <thead>
              <tr>
                <th class="column-name">Name</th>
                @if (showDataTypeColumn()) {
                  <th class="column-data-type">Data Type</th>
                }
                @if (showSelectionColumn()) {
                  <th class="column-name">Selection</th>
                }
                @if (showMapsToColumn()) {
                  <th>Maps To</th>
                }
                @if (showMapsToColumn()) {
                  <th class="column-name">Linked Record ID</th>
                }
                @if (showSyncListColumn()) {
                  <th class="column-sync-list">Sync List</th>
                }
                @if (showIdentifierColumn()) {
                  <th class="column-identifier">Identifier</th>
                }
                @if (showSearchKeyColumn()) {
                  <th class="column-search-key">Search Key</th>
                }
                @if (showLevelColumn()) {
                  <th class="column-name">Level</th>
                }
                @if (showNaturalKeyColumn()) {
                  <th class="column-natural-key">Natural Key</th>
                }
                @if (showEnabledColumn()) {
                  <th class="column-enabled">Enabled</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (df of model.DataFields; track df; let i = $index) {
                <tr ng-class="{'list-with-attributes': sListWithAttributes(i)}">
                  <td ngClass="{{ !model.DataFields[i].Enabled && 'mat-label-disabled column-name' || 'column-name' }}">{{df.Name}}</td>
                  @if (showDataTypeColumn()) {
                    <td class="column-data-type">
                      <mat-select matInput name="DataType-{{i}}" [(ngModel)]="model.DataFields[i].DataType" (selectionChange)="calculateSyncColumn()" id="feed-data-field-dropdown-{{i}}">
                        @for (dt of dataTypes; track dt) {
                          <mat-option [value]="dt.Key" id="feed-data-field-dropdown-{{i}}-{{dt.Key}}">
                            {{ dt.FriendlyName }}
                          </mat-option>
                        }
                      </mat-select>
                    </td>
                  }
                  @if (showSelectionColumn()) {
                    <td class="column-name">
                      @if (model.DataFields[i].DataType==='list') {
                        <mat-select
                          matInput
                          name="ListKey-{{i}}"
                          (selectionChange)="calculateSyncDisabled()"
                          [(ngModel)]="model.DataFields[i].ListKey"
                          id="feed-field-selection-dropdown-{{i}}">
                          @for (list of lists; track list) {
                            <mat-option [value]="list.Key" id="feed-selection-dropdown-{{i}}-{{list.Key}}">
                              {{ list.FriendlyName }}
                            </mat-option>
                          }
                        </mat-select>
                      }
                      @if (model.DataFields[i].DataType==='hierarchy') {
                        <mat-select
                          mdInput
                          name="Hierarchy-{{i}}"
                          [(ngModel)]="model.DataFields[i].ListKey"
                          id="feed-hierarchy-dropdown-{{i}}">
                          @for (hierarchyType of hierarchyTypes; track hierarchyType) {
                            <mat-option [value]="hierarchyType.Key" id="feed-hierarchy-dropdown-{{i}}-{{hierarchyType.Key}}">
                              {{ hierarchyType.FriendlyName }}
                            </mat-option>
                          }
                        </mat-select>
                      }
                      @if (isHierarchyAttributesDataType(i)) {
                        <mat-select
                          mdInput
                          name="Attributes-{{i}}"
                          (selectionChange)="onHierarchyAttributeLocationChanged($event.value, i)"
                          [(ngModel)]="selectedAttributes[i]"
                          id="feed-attributes-dropdown-{{i}}">
                          @for (hierarchyAttribute of hierarchyAttributes; track hierarchyAttribute) {
                            <mat-option [value]="hierarchyAttribute" id="feed-attributes-dropdown-{{i}}-{{hierarchyAttribute.AttributeId}}">
                              {{ hierarchyAttribute.AttributeName }}
                            </mat-option>
                          }
                        </mat-select>
                      }
                      @if (model.DataFields[i].DataType==='date') {
                        <mat-select
                          mdInput
                          name="FormatString-{{i}}"
                          [(ngModel)]="model.DataFields[i].FormatString"
                          id="feed-date-field-dropdown-{{i}}">
                          @for (formatString of formatStrings; track formatString) {
                            <mat-option [value]="formatString.Key" id="feed-date-field-dropdown-{{i}}-{{formatString.Key}}">
                              {{formatString.FriendlyName}}
                            </mat-option>
                          }
                        </mat-select>
                      }
                      @if (isOshaEstablishmentFeed() || isHierarchyOshaAttributesFeed()) {
                        <mat-select
                          mdInput
                          name="OshaEstablishment-{{i}}"
                          [(ngModel)]="model.DataFields[i].ListKey"
                          id="feed-osha-dropdown-{{i}}">
                          @for (oshaEstablishmentType of oshaEstablishmentTypes; track oshaEstablishmentType) {
                            <mat-option [value]="oshaEstablishmentType.Key" id="feed-osha-dropdown-{{i}}-{{oshaEstablishmentType.Key}}">
                              {{oshaEstablishmentType.FriendlyName}}
                            </mat-option>
                          }
                        </mat-select>
                      }
                    </td>
                  }
                  @if (isModuleRecordFeed()) {
                    <td>
                      <mat-select mdInput
                        name="ModuleRecordFeed-{{i}}"
                        [disabled]="!model.DataFields[i].Enabled"
                        [ngModel]="mapsToKey(model.DataFields[i])"
                        (selectionChange)="mapsToChanged($event.value, i)"
                        id="feed-formflow-field-dropdown-{{i}}">
                        @for (entity of mappableEntities; track entity) {
                          <mat-option [value]="mappableEntityKey(entity)"
                            id="feed-formflow-field-dropdown-{{i}}-{{entity.FieldId}}">
                            {{entity.PathLabel}}
                          </mat-option>
                        }
                      </mat-select>
                    </td>
                  }
                  @if (isModuleRecordFeed()) {
                    <td class="column-linked-record-id">
                      @if (model.DataFields[i].LinkedRecordModuleId) {
                        <div>
                          <mat-select mdInput
                            name="ModuleRecordFeedExternal-{{i}}"
                            [disabled]="!model.DataFields[i].Enabled"
                            [ngModel]="model.DataFields[i].LinkedRecordExternalIdProperty"
                            (selectionChange)="externalIdChanged($event.value, i)"
                            id="feed-formflow-field-exernal-dropdown-{{i}}">
                            @for (linkOption of getLinkedRecordOptions(model.DataFields[i].LinkedRecordModuleId); track linkOption) {
                              <mat-option [value]="linkOption"
                                id="feed-formflow-field-external-dropdown-{{i}}-{{linkOption}}">
                                {{linkOption}}
                              </mat-option>
                            }
                          </mat-select>
                        </div>
                      } @else {
                        <div>N/A</div>
                      }
                    </td>
                  }
                  @if (showSyncListColumn()) {
                    <td class="column-sync-list">
                      @if (model.DataFields[i].DataType==='list') {
                        <mat-checkbox name="SyncListCheckBox-{{i}}"
                          [disabled]="model.DataFields[i].DisableSync"
                          [(ngModel)]="model.DataFields[i].SyncList"
                          (change)="calculateSyncDisabled()"
                        id="feed-sync-list-{{i}}"></mat-checkbox>
                      }
                    </td>
                  }
                  @if (showIdentifierColumn()) {
                    <td class="column-identifier">
                      <mat-checkbox name="IdentifierCheckBox-{{i}}" [(ngModel)]="model.DataFields[i].IsIdentifier" (change)="checkIdentifierCount()" id="feed-is-identifier-{{i}}"></mat-checkbox>
                    </td>
                  }
                  @if (showSearchKeyColumn()) {
                    <td class="column-search-key">
                      <mat-checkbox name="IsSearchKeyCheckBox-{{i}}" [(ngModel)]="model.DataFields[i].IsSearchKey" id="feed-search-key-{{i}}"></mat-checkbox>
                    </td>
                  }
                  @if (showLevelColumn()) {
                    <td class="column-name">
                      @if (!isHierarchyAttributesDataType(i)) {
                        <mat-select matInput name="LocationLevel-{{i}}" [(ngModel)]="model.DataFields[i].LocationLevel" id="feed-location-level-dropdown-{{i}}">
                          @for (lv of locationLevels; track lv) {
                            <mat-option [value]="lv.LevelAlias" id="feed-location-level-dropdown-{{i}}-{{lv.LevelAlias}}">
                              {{ lv.LevelName }}
                            </mat-option>
                          }
                        </mat-select>
                      }
                      @if (isHierarchyAttributesDataType(i)) {
                        <mat-select [(ngModel)]="model.DataFields[i].LocationLevel" name="LocationLevel-{{i}}">
                          <mat-option id="feed-location-level-dropdown-{{i}}-Site" [value]="reportingPoint">
                            SITE
                          </mat-option>
                        </mat-select>
                      }
                    </td>
                  }
                  @if (showNaturalKeyColumn()) {
                    <td class="column-enabled">
                      @if (isValidNaturalKey(i)) {
                        <mat-slide-toggle name="natural-key-{{i}}" [(ngModel)]="model.DataFields[i].IsNaturalKey" [disabled]="!model.DataFields[i].Enabled" id="feed-column-natural-key-{{i}}"></mat-slide-toggle>
                      }
                    </td>
                  }
                  @if (showEnabledColumn()) {
                    <td class="column-enabled">
                      <mat-slide-toggle name="enabled-{{i}}" [(ngModel)]="model.DataFields[i].Enabled" [disabled]="isDataFieldMappedToMandatoryField(model.DataFields[i])" id="feed-column-enabled-{{i}}" (change)="fieldDisabled(model.DataFields[i])"></mat-slide-toggle>
                    </td>
                  }
                </tr>
                @if (isListWithAttributes(i)) {
                  <tr class="attribute-mappings" >
                    <td colspan="11" class="attribute-mappings-container" >
                      <mat-accordion>
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>Attribute Mappings</mat-panel-title>
                          </mat-expansion-panel-header>
                          <table>
                            @for (att of getAssociatedAttributeMappings(i); track att; let j = $index) {
                              <tr>
                                <td ngClass="{{ !att.Enabled && 'mat-label-disabled column-name' || 'column-name' }}">{{att.AttributeName}}</td>
                                <td class="column-data-type">
                                  <mat-select mdInput
                                    name="ModuleRecordFeed-{{i}}-Attribute-{{j}}"
                                    [disabled]="!att.Enabled"
                                    [ngModel]="mapsToKey(att)"
                                    (selectionChange)="attributeMapsToChanged($event.value, i, j)"
                                    id="feed-formflow-field-attribute-dropdown-{{i}}-{{j}}">
                                    @for (entity of mappableEntities; track entity) {
                                      <mat-option [value]="mappableEntityKey(entity)"
                                        id="feed-formflow-field-attribute-dropdown-{{i}}-{{j}}-{{entity.FieldId}}">
                                        {{entity.PathLabel}}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </td>
                                @if (isModuleRecordFeed()) {
                                  <td>
                                    @if (att.LinkedRecordModuleId) {
                                      <div>
                                        <mat-select mdInput
                                          name="ModuleRecordFeedExternal-{{i}}-Attribute-{{j}}"
                                          [disabled]="!att.Enabled"
                                          [ngModel]="att.LinkedRecordExternalIdProperty"
                                          (selectionChange)="attributeExternalIdChanged($event.value, i, j)"
                                          id="feed-formflow-field-exernal-dropdown-{{i}}">
                                          @for (linkOption of getLinkedRecordOptions(att.LinkedRecordModuleId); track linkOption) {
                                            <mat-option [value]="linkOption"
                                              id="feed-formflow-field-external-dropdown-{{i}}-{{j}}-{{linkOption}}">
                                              {{linkOption}}
                                            </mat-option>
                                          }
                                        </mat-select>
                                      </div>
                                    } @else {
                                      <div>N/A</div>
                                    }
                                  </td>
                                }
                                @if (showNaturalKeyColumn()) {
                                  <td class="column-enabled">
                                    @if (isAttributeValidNaturalKey(att)) {
                                      <mat-slide-toggle name="natural-key-{{i}}-{{j}}" [(ngModel)]="att.IsNaturalKey" [disabled]="!att.Enabled" id="feed-column-natural-key-{{i}}-{{j}}"></mat-slide-toggle>
                                    }
                                  </td>
                                }
                                @if (showEnabledColumn()) {
                                  <td class="column-enabled">
                                    <mat-slide-toggle name="enabled-{{i}}-{{j}}" [(ngModel)]="att.Enabled" id="feed-column-attreibute-enabled-{{i}}-{{j}}"></mat-slide-toggle>
                                  </td>
                                }
                              </tr>
                            }
                          </table>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          @if (model.DataFields.length > 0 && !isDataFieldsValid()) {
            <div class="error-message-container with-icon pull-right" id="ErrorMessage_SearchKeyInvalid">
              <mat-icon>error</mat-icon><strong>Please select at least one Search Key</strong>
            </div>
          }
          @if (model.DataFields.length > 0 && !isHierarchyFeedValid() && isReportingPointLevelMapped()) {
            <div class="error-message-container with-icon pull-right" id="ErrorMessage_DuplicateLocationLevels">
              <mat-icon>error</mat-icon><strong>Duplicate Location Levels Selected</strong>
            </div>
          }
          @if (model.DataFields.length > 0 && !isHierarchyDataFieldsValid()) {
            <div class="error-message-container with-icon pull-right" id="ErrorMessage_UnmappedData">
              <mat-icon>error</mat-icon><strong>Un-mapped data. Please ensure all fields are mapped.</strong>
            </div>
          }
          @if (model.DataFields.length > 0 && !isHierarchyFeedValid() && !isReportingPointLevelMapped()) {
            <div class="error-message-container with-icon pull-right" id="ErrorMessage_ReportingPointNotMapped">
              <mat-icon>error</mat-icon><strong>Please map the Reporting Point Level</strong>
            </div>
          }
          @if (model.DataFields.length > 0 && !isOshaEstablishmentFeedValid()) {
            <div class="error-message-container with-icon pull-right" id="ErrorMessage_OneFieldOnlyMappedToId">
              <mat-icon>error</mat-icon><strong>Please map one and only one field to the ID.</strong>
            </div>
          }
          @if (isModuleRecordFeed() && !areMandatoryFieldsMapped()) {
            <div class="error-message-container with-icon pull-right" id="ErrorMessage_MandatoryFieldsNotMapped">
              <mat-icon>error</mat-icon><strong>All mandatory fields for feed must be mapped.</strong>
            </div>
          }
          @if (isModuleRecordFeed() && !hasNaturalKey()){
            <div class="error-message-container with-icon pull-right" id="ErrorMessage_NoNaturalKey">
              <mat-icon>error</mat-icon><strong>Please select at least one Natural Key</strong>
            </div>
          } 
          <div class="clear"></div>
          <ng-template #loading>
            Loading Feed Configuration...
          </ng-template>
        </mat-card-content>
        <mat-card-actions>
          <div class="align-right save-button-container">
            <button mat-raised-button type="submit"
              [disabled]="!formCanSubmit(feedConfigurationForm)"
              class="mat-raised-button"
              color="accent"
              id="feed-save" data-qa-id="feeds-detail-btn-save">
              Save
            </button>
            <button mat-raised-button type="button"
              (click)="onCancelButtonClick()"
              class="mat-raised-button"
              color="warn"
              id="feed-cancel" data-qa-id="feeds-detail-btn-cancel">
              Cancel
            </button>
          </div>
          @if (saveFeedConfigurationErrorText) {
            <div class="error-message-container">
              <div class="with-icon pull-right">
                <mat-icon>error</mat-icon><strong>{{saveFeedConfigurationErrorText}}</strong>
              </div>
              <div class="clear"></div>
            </div>
          }
        </mat-card-actions>
        <mat-card-footer>
          @if (model.Id!==emptyGuid && !isHierarchyFeed() && !isOshaEstablishmentFeed()) {
            <div class="with-icon">
              <mat-icon>info</mat-icon>
              <strong>
                Once you have selected and saved the fields to use, <a routerLink="../../modules"
              preserveFragment>navigate to the Modules</a> tab to configure the mappings and what
              populates
              on the form.
            </strong>
          </div>
        }
      </mat-card-footer>
    </form>
  }
</mat-card>
</section>
